import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchUserTrainingProgramsSuccess,
  fetchUserTrainingProgramsFailed,
  fetchUserTrainingProgramsStart,
} from "./training-programs-slice";
import { IBaseResponse } from "../../../../interfaces/base";
import { IFetchUserTrainingProgramsAction } from "../../../../interfaces/store/user-interfaces";
import {
  getActiveTrainingPrograms,
  getFinishedTrainingPrograms,
  getUnfinishedTrainingPrograms,
} from "../../../../api/accounts/user-training-programs";

function* _fetchTrainingPrograms({
  payload,
}: IFetchUserTrainingProgramsAction) {
  try {
    const { skip, limit, userId, type, page } = payload;

    let response: IBaseResponse = { data: null, error: null };
    if (type === "active") {
      response = yield call(getActiveTrainingPrograms, userId);
    } else if (type === "finished") {
      response = yield call(getFinishedTrainingPrograms, userId, skip, limit);
    } else if (type === "unfinished") {
      response = yield call(getUnfinishedTrainingPrograms, userId, skip, limit);
    } else {
      throw new Error(`Invalid type: ${type}`);
    }

    if (response.error) {
      yield put(fetchUserTrainingProgramsFailed(response.error));
    } else {
      if (type === "active") {
        yield put(
          fetchUserTrainingProgramsSuccess({
            data: {
              data: response.data,
              metadata: {
                total: response.data.length,
                page: 1,
              },
            },
          })
        );
      } else {
        yield put(
          fetchUserTrainingProgramsSuccess({
            data: {
              data: response.data.data,
              metadata: {
                total: response.data.total,
                page: page,
              },
            },
          })
        );
      }
    }
  } catch (error: any) {
    console.log("error:", error);
    yield put(fetchUserTrainingProgramsFailed({ message: error.message }));
  }
}

function* userTrainingProgramsSaga() {
  yield takeLatest(fetchUserTrainingProgramsStart.type, _fetchTrainingPrograms);
}

export default userTrainingProgramsSaga;
